import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpringComponent } from './simple-icons-spring.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpringComponent ],
    exports:      [ SimpleIconsSpringComponent ],
    bootstrap:    []
})
export class SimpleIconsSpringModule {}
